/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_MultichannelInputs */



/**
* | output |
* | --- |
* | "Multi-Channel Audio Support" |
*
* @param {Signup_Compare_MultichannelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_multichannel = /** @type {((inputs?: Signup_Compare_MultichannelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_MultichannelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "de") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "it") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "es") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
	return /** @type {LocalizedString} */ ("Multi-Channel Audio Support")
});